import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import Cards from './Card'
import { SocketContext, UserContext } from '../context/UserContext'
import * as mediasoupClient from 'mediasoup-client';
import PageLoader from './PageLoader';
import { callAPI } from '../helper/apiHelper';
import { API_URL_ENDPOINT, BASE_URL } from '../appsetting/appsetting';
import StreamElement from './StreamElement';
import NewCard from './NewCard';


let audioProducerTransport = null;
let audioConsumerTransport = null;

const Seats = ({room, seatLayout}) => {
    const { globalUser, updateUser,  login } = useContext(UserContext);
    const { socket } = useContext(SocketContext)
    const audioTrack = useRef(null);
    const device = useRef(null);
    const [isTransportReady, setIsTransportReady] = useState(false);

    const [streams, setStreams] = useState(Array(6).fill(null));
    const [localSeatLayout, setLocalSeatLayout] = useState(Array(6).fill(null))

    useEffect(()=>{
        if(!seatLayout) return;
        setLocalSeatLayout(seatLayout)
    },[seatLayout])

    useEffect(()=>{
        if(!socket || !globalUser) return;
        const handleNewProducerJoined = (data) => {
            const { producerID, userID, SeatNo } = data;
            console.log("New Producer Joined", producerID)
            ConsumeAudioTracks(producerID, userID);

            setLocalSeatLayout(prevLayout =>
                prevLayout.map(layout =>
                    layout?.SeatNo === SeatNo ? { ...layout, UserID: userID, ProducerID: producerID } : layout
                )
            );
        }

        const handleMicStatusChanged = async(data) =>{
            const {userid, status} = data;
            if(userid == globalUser?.ID && audioTrack.current){
              audioTrack.current.enabled = status;
            }
        }

        const handleProducerDisconnect = (data) => {
            const {userid} = data;
            //Remove User From Seat
            RemoveFromSeat(userid)
        }

        socket.on('NewProducerJoined', handleNewProducerJoined)
        socket.on('MicStatusChanged', handleMicStatusChanged)
        socket.on('mic-off-by-host',(userid)=>audioTrack.current.enabled = false)
        socket.on('ProducerDisconnect', handleProducerDisconnect)


        return () => {
            socket.off('NewProducerJoined');
            socket.off('MicStatusChanged');
            
            socket.off('ProducerDisconnect');

            // Reset states
            setLocalSeatLayout(Array(6).fill(null));
            setIsTransportReady(false);
        }
    },[socket, globalUser])

    useEffect(()=>{
        // if(!globalUser || !socket) return;
        async function StartAPP(){
            try{
                await getLocalAudio();
                const rtpCapabilities = await new Promise(resolve => {
                    socket.emit('getRouterRtpCapabilities', resolve);
                });

                device.current = new mediasoupClient.Device();
                await device.current.load({routerRtpCapabilities : rtpCapabilities });
                await createConsumerTransport(socket, globalUser?.ID)             
                setIsTransportReady(true);
                // await startProduceAndConsume()
            }catch(error){
                console.log(error)
            }
        };

        StartAPP();

        socket.on('RequestAccepted', handleRequestAccepted)
        return () => {
            socket.off('RequestAccepted');
            // Stop audio track
            if (audioTrack.current) {
                audioTrack.current.stop();
                audioTrack.current = null;
            }

            //Close Mediasoup transports sjkdgh lkdsh
            if (audioProducerTransport) {
                audioProducerTransport.close();
                audioProducerTransport = null;
            }
            if (audioConsumerTransport) {
                audioConsumerTransport.close();
                audioConsumerTransport = null;
            }

            // Clear device reference
            // if (device.current) {
            //     device.current = null;
            // }
        }
    },[])

    useEffect(()=>{
        if(!isTransportReady) return;
        seatLayout.map((obj, index) => {
            if (obj.ProducerID && obj.UserID !== globalUser.ID) {        
                ConsumeAudioTracks(obj.ProducerID, obj.UserID);
            }
            if (obj.UserID === globalUser.ID) {
                StartProducing(obj?.SeatNo, device.current);
            }
            return null;
        });
    },[isTransportReady])

    const createProducerTransport = async (seatNo, deviceInstance) => {
        const audioProducerTransportOptions = await new Promise(resolve => {
            socket.emit('createAudioProducerTransport', { userID: globalUser?.ID }, (response) => {
                resolve(response);
            });
        });
        
        audioProducerTransport = deviceInstance.createSendTransport(audioProducerTransportOptions);

        audioProducerTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
            console.log("Transport connecting...");
            socket.emit('connectAudioProducerTransport', { userID : globalUser?.ID, dtlsParameters }, callback);
            callback();
            console.log("Transport connected");
        });
        
        audioProducerTransport.on('produce', async ({ kind, rtpParameters }, callback) => {
            socket.emit('produceAudio', {userID : globalUser?.ID, isHost : globalUser?.isHost, userSeat : seatNo, kind, rtpParameters }, response => {
                callback({ producerId: response.id });
            });
        });
    }

    const createConsumerTransport = async (socket, userid) => {
        const consumerAudioTransportOptions = await new Promise(resolve => {
            socket.emit('createConsumerAudioTransport', {userID : userid}, resolve);
        });
        
        audioConsumerTransport = device.current.createRecvTransport(consumerAudioTransportOptions);
        audioConsumerTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
            socket.emit('connectConsumerAudioTransport', {userID : userid, dtlsParameters }, callback);
            callback();
        });

        // Handle transport closure
        audioConsumerTransport.on('close', async () => {
            console.warn("Transport closed, recreating...");
            await recreateConsumerTransport(socket, userid);
        });

        // Handle transport connection failure
        audioConsumerTransport.on('failed', async (error) => {
            console.error("Transport failed:", error);
            await recreateConsumerTransport(socket, userid);
        });
    }

    const recreateConsumerTransport = async (socket, userid) => {
        setIsTransportReady(false);
        if (audioConsumerTransport) {
            audioConsumerTransport.close();
            audioConsumerTransport = null;
        }
    
        console.log("Recreating transport...");
        await createConsumerTransport(socket, userid);
        setIsTransportReady(true);
    };

    const getLocalAudio = async () => {  
        const stream = await navigator.mediaDevices.getUserMedia({ 
            audio: {
                echoCancellation: true,  // Reduce echo
                noiseSuppression: true,  // Reduce background noise
                autoGainControl: true,    // Adjust mic sensitivity
                channelCount: 1,             // Use mono audio for better clarity
                sampleRate: 48000,           // High sample rate for clear voice
                sampleSize: 16
            }, video: false 
        });
        // createAudioFilter(stream);

        let audTrack;
        stream.getTracks().forEach(track => {
          if (track.kind === 'audio') audTrack = track;
        })
        audioTrack.current = audTrack;
        audioTrack.current.enabled = false;
        return {audTrack, stream };
    };

    const createAudioFilter = (stream) => {
        const audioContext = new AudioContext();
        const source = audioContext.createMediaStreamSource(stream);
        
        // High-pass filter to remove low background noise
        const highPassFilter = audioContext.createBiquadFilter();
        highPassFilter.type = "highpass";
        highPassFilter.frequency.value = 200; // Removes deep hums and background noise
    
        source.connect(highPassFilter);
        highPassFilter.connect(audioContext.destination);
    };

    const detectSpeaking =  useCallback(() => {
        if (!audioTrack.current || !socket || !globalUser) {
            return;
        }
        
        // Create a MediaStream from the AudioTrack
        const stream = new MediaStream([audioTrack.current]);
        
        // Initialize Web Audio API
        const audioContext = new AudioContext();
        const analyser = audioContext.createAnalyser();
        const source = audioContext.createMediaStreamSource(stream);
        
        source.connect(analyser);
        analyser.fftSize = 512; // Adjust sensitivity
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
        
        const checkVolume = () => {
            analyser.getByteFrequencyData(dataArray);
            let sum = 0;
            for (let i = 0; i < bufferLength; i++) {
                sum += dataArray[i];
            }
            let average = sum / bufferLength;
            
            if (average > 10) {
                // console.log("Speaking")
                socket.emit("UserSpeak", {UserID:globalUser?.ID})
                // console.log("User is speaking");
            } else {
                // console.log("Speakingsd")
                // console.log("User is silent");
            }
    
            requestAnimationFrame(checkVolume);
        };
    
        checkVolume();
    },[audioTrack.current, socket, globalUser]);

    const StartProducing = useCallback(async (seatNo, deviceInstance) => {
        if(seatLayout.length == 0) return;
        await createProducerTransport(seatNo, deviceInstance);
        try{
            console.log("Transport state:", audioProducerTransport?.connectionState);
            await audioProducerTransport.produce({
                codecOptions: {
                    opusStereo: true, 
                    opusDtx: true,    
                    audioGoogleNoiseSuppression: true,
                    audioGoogleAutomaticGainControl: true,
                    audioGoogleEchoCancellation: true
                },
                track: audioTrack.current
            })
        }catch(error){
            console.log("Error", error)
        }
        detectSpeaking();
    },[seatLayout, globalUser])

    const ConsumeAudioTracks = async (producerID, userID = 0) => {
        try {
            if(!device.current || !globalUser) return;
            const consumeAudio = await new Promise((resolve) => {
                const rtpCapabilities = device.current?.rtpCapabilities;
                socket.emit('consumeAudio', { userID : globalUser?.ID, rtpCapabilities, producerID }, resolve);
            });
        
            if (consumeAudio.error) {
                console.error("Cannot Consume Audio:", userID, consumeAudio.error);
                // if (!attemptedUsers.includes(userID)) {
                //     socket.emit('tryToConsumeFromServer', { userID });
                //     console.error("Cannot consume Audio:", userID, consumeAudio.error);

                //     attemptedUsers.push(userID);
                //     localStorage.setItem('attemptedUsers', JSON.stringify(attemptedUsers));
                // } else {
                //     console.warn(`Already tried consuming audio for userID: ${userID}`);
                // }
                return;
            }
        
            const consumer = await audioConsumerTransport.consume({
                id: consumeAudio.id,
                producerId: consumeAudio.producerId,
                kind: consumeAudio.kind,
                rtpParameters: consumeAudio.rtpParameters,
            });
        
            const { track } = consumer;
            const remoteStream = new MediaStream([track]);
            
        
            // const sobj = {
            //     stream: remoteStream,
            //     producerName: consumeAudio?.FullName,
            //     profile: consumeAudio?.Profile,
            //     producerId: consumeAudio?.producerId,
            //     seatNo: consumeAudio?.SeatNo,
            //     isHost: consumeAudio?.isHost,
            //     userID : consumeAudio?.userID,
            //     isMicOn : consumeAudio?.isMicOn,
            // };
            // const updatedUsers = attemptedUsers.filter(id => id !== userID);
            // localStorage.setItem('attemptedUsers', JSON.stringify(updatedUsers));
            // addoaudiostream(sobj);
    
            const consumerstream = {
                UserID: consumeAudio?.userID,
                Stream: remoteStream 
            }
            setStreams((prevStreams) => {
                if (!Array.isArray(prevStreams)) {
                    return Array(6).fill(null); // Ensure the array is initialized
                }
                const existingIndex = prevStreams.findIndex(s => s && s.UserID === consumeAudio?.userID);
                let updatedStreams = [...prevStreams];
                if (existingIndex !== -1) {
                    updatedStreams[existingIndex] = consumerstream;
                } else {
                    // Find an empty slot
                    const emptyIndex = updatedStreams.findIndex(s => s === null);
                    if (emptyIndex !== -1) {
                        updatedStreams[emptyIndex] = consumerstream;
                    } else {
                        updatedStreams.push(consumerstream);
                    }
                }
                return [...updatedStreams];
            });            

        } catch (error) {
            console.error("Error in ConsumeTracks:", error);
        }
    }

    const handleRequestAccepted = (data) => {
        const {userID, seatNo} = data;
        setLocalSeatLayout(prevLayout =>
            prevLayout.map(layout =>
                layout?.SeatNo === seatNo ? { ...layout, UserID: userID ?? globalUser?.ID, ProducerID: null } : layout
            )
        );
        StartProducing(seatNo, device.current);
    }

    const handleRetryConsume = (producerID) => {
        // console.log("Retry Consume");
        // recreateConsumerTransport(socket, globalUser?.ID);        
    }

    const handleLeaveSeat = (userid) => {
        //Remove From Layout
        RemoveFromSeat(userid);
        socket.emit('ProducerLeaveSeat', ({userID : userid}))
    }

    const RemoveFromSeat = (userid) => {
        setLocalSeatLayout(prevLayout =>
            prevLayout.map(layout =>
                layout?.UserID === userid ? { ...layout, UserID: 0, ProducerID: null } : layout
            )
        );
        setStreams(prevStreams =>
            prevStreams.map(stream => (stream?.UserID === userid ? null : stream))
        );
    }

  return (
    <>
        <PageLoader show={!isTransportReady} text='Creating Transports...'/>
        <div className='row'>
            {
                localSeatLayout?.map((seat, index)=>(
                    <div key={index} className='col-4'>
                        <NewCard seat={seat} leaveSeat={handleLeaveSeat}/>
                    </div>
                ))
            }
            {
                streams?.map((strm, index)=>(
                    <StreamElement key={index} stream={strm} />
                ))
            }
        </div>
    </>
  )
}

export default Seats